import { Button, DatePicker, Popconfirm, Spin, TableColumnsType, message } from 'antd'
import Axios from 'axios'
import React, { useEffect } from 'react'
import { saveAs } from 'file-saver'
import Table from '../../component/table'
import moment from 'moment'

interface IProps {}

const ReportList: React.FC<IProps> = props => {
    const [data, setData] = React.useState([])
    const [loading, setLoading] = React.useState(false)

    const fetch = () => {
        setLoading(true)
        Axios.get('reports', {})
            .then(res => {
                setData(
                    res.data.map((row: any, i: number) => ({
                        ...row,
                        key: i,
                    }))
                )
            })
            .catch(err => {
                console.error(err)
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        fetch()
    }, [])

    const confirmDelete = (record: any) => {
        Axios.delete(`/reports/${record.filename}`, {}).then(res => fetch())
        message.success('Deleted')
    }

    const columns = (): TableColumnsType => {
        return [
            {
                title: 'File name',
                dataIndex: 'filename',
                sorter: (a: any, b: any) => (a.start > b.start ? -1 : 1),
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <DatePicker
                        onChange={(date, dateString) => {
                            if (dateString !== '') {
                                setSelectedKeys([
                                    moment(date)
                                        .startOf('isoWeek')
                                        .format('YYYYMMDD'),
                                ])
                                confirm()
                            } else {
                                setSelectedKeys([''])
                                clearFilters!()
                                confirm()
                            }
                        }}
                    />
                ),
                onFilter: (value, record: any) =>
                    record.filename
                        .toString()
                        .toLowerCase()
                        .includes((value as string).toLowerCase()),
            },
            {
                title: 'Download',
                key: 'action',
                render: (_, record: any) => (
                    <Button
                        type="primary"
                        onClick={() => {
                            Axios.get(`/reports/${record.filename}`, {
                                responseType: 'blob',
                            })
                                .then(res => {
                                    const filename = res.headers['content-disposition']
                                        .split(`filename="`)[1]
                                        .slice(0, -1)
                                    saveAs(res.data, filename)
                                })
                                .catch(err => console.error)
                                .finally(() => {})
                        }}
                    >
                        Download
                    </Button>
                ),
            },
            {
                title: 'Delete',
                key: 'action',
                render: (_, record: any) => (
                    <Popconfirm
                        title="Are you sure to delete this file?"
                        onConfirm={e => confirmDelete(record)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button type="primary" danger>
                            Delete
                        </Button>
                    </Popconfirm>
                ),
            },
        ]
    }

    return (
        <Spin spinning={loading}>
            <div>
                <Table
                    columns={columns()}
                    data={data}
                    expandedRowRender={record => (
                        <div key={record.filename}>
                            <div>Angle Threshold (Roll): {record.paras.angleThresholdRoll}</div>
                            <div>Angle Threshold (Pitch): {record.paras.angleThresholdPitch}</div>
                            <div>RSSI Level: {record.paras.rssiLevel}</div>
                            <div>CSQ Level: {record.paras.CSQLevel}</div>
                            <div>Uplink Successful Rate (USR) %: {record.paras.uplinkSuccessfulRate}</div>
                            <div>Battery Alert Threshold: {record.paras.batteryAlertThreshold}</div>
                            <div>Large Angle (Roll): {record.paras.largeAngleRoll}</div>
                            <div>Large Angle (Pitch): {record.paras.largeAnglePitch}</div>
                            <div>Tilting Angle Threshold: {record.paras.tiltingAngleThreshold}</div>
                            <div>Hour: {record.paras.hour}</div>
                        </div>
                    )}
                />
            </div>
        </Spin>
    )
}

export default ReportList
